import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import ajax from '../utils/ajaxHelper';
import { getHostType } from '../utils';

const useImport = () => {
  const { roleId } = useParams();
  const callAPi = useCallback(
    async (url, values, { setErrors, setStatus, setSubmitting }, callback) => {
      const data = values;
      try {
        await ajax
          .post(url, data, {
            networkParams: { showLoader: false },
            headers: {
              hosttype: getHostType(roleId),
            },
          })
          .then((res) => {
            callback(res);
          });
      } catch (error) {
        setStatus({ success: false });
        setErrors({ submit: error.message });
        callback(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    },
    [roleId],
  );
  const importDataToTable = useCallback(
    async (values, actions, progressCallback) => {
      try {
        return await ajax.post('import/import-data', values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          networkParams: { showLoader: false },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
          },
        });
      } catch (error) {
        console.log(error, 404);
        return error;
      }
    },
    [callAPi],
  );
  const importCsvData = useCallback(
    async (values, actions, progressCallback) => {
      try {
        console.log(values, 6666);
        return await ajax.post('import/import-csv-data', values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          networkParams: { showLoader: false },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
          },
        });
      } catch (error) {
        console.log(error, 404);
        return error;
      }
    },
    [callAPi],
  );

  const importCollectionReportData = useCallback(
    async (values, actions, progressCallback) => {
      try {
        return await ajax.post('import/collection-report-data', values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          networkParams: { showLoader: false },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
          },
        });
      } catch (error) {
        console.log(error, 404);
        return error;
      }
    },
    [callAPi],
  );

  const updateDataToTable = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-imported-data', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const updateConpanyFinacialProgressionData = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-conpany-finacial-progression-data', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const updateFinancialPerformanceEmployeeData = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-financial-Performance-employee-data', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  const updatePersonalData = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-personal-data', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  const updateEmployeeRecordsData = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-employee-records-data', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  const updateFinancialCompensationData = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-financial-compensation-data', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const getImportFieldNames = useCallback(
    async (values) => {
      try {
        const val = { setName: values?.setName };
        const result = await ajax.post('import/get-import-field-names', val);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  const getConpanyFinacialProgressionData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-conpany-finacial-progression-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });
  const getPersonalData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-personal-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getFinancialPerformanceEmployeeData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-financial-performance-employee-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });
  const getEmployeeRecordsData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-employee-records-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });
  const getFinancialCompensationData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-financial-compensation-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getSampleData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-sample-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const loadExcelDataToMainTable = useCallback(async (val, progressCallback) => {
    try {
      let result = await ajax.post(`import/load-excel-to-main-table`, val, {
        networkParams: { showLoader: false },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          progressCallback(percentCompleted);
        },
      });
      return result;
    } catch (error) {
      return error;
    }
  });

  const loadFinancialPerformanceEmployeeData = useCallback(async (val, progressCallback) => {
    try {
      let result = await ajax.post(
        `import/load-excel-to-financial-performance-employee-data-table`,
        val,
        {
          networkParams: { showLoader: false },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
          },
        },
      );
      return result;
    } catch (error) {
      return error;
    }
  });

  const loadExcelDataToConpanyFinacialProgressionTable = useCallback(
    async (val, progressCallback) => {
      try {
        let result = await ajax.post(
          `import/load-excel-data-to-conpany-finacial-progression-table`,
          val,
          {
            networkParams: { showLoader: false },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              progressCallback(percentCompleted);
            },
          },
        );
        return result;
      } catch (error) {
        return error;
      }
    },
  );

  const loadExcelDataToPersonalDataTable = useCallback(async (val, progressCallback) => {
    try {
      let result = await ajax.post(`import/load-excel-data-to-personal-data-table`, val, {
        networkParams: { showLoader: false },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          progressCallback(percentCompleted);
        },
      });
      return result;
    } catch (error) {
      return error;
    }
  });

  const loadExcelDataToEmployeeRecordsDataTable = useCallback(async (val, progressCallback) => {
    try {
      let result = await ajax.post(`import/load-excel-data-to-employee-records-data-table`, val, {
        networkParams: { showLoader: false },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          progressCallback(percentCompleted);
        },
      });
      return result;
    } catch (error) {
      return error;
    }
  });

  const loadExcelDataToFinancialCompensationDataTable = useCallback(
    async (val, progressCallback) => {
      try {
        let result = await ajax.post(
          `import/load-excel-data-to-financial-compensation-data-table`,
          val,
          {
            networkParams: { showLoader: false },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              progressCallback(percentCompleted);
            },
          },
        );
        return result;
      } catch (error) {
        return error;
      }
    },
  );

  const loadExcelDataToCollectionReportTable = useCallback(async (val, progressCallback) => {
    try {
      let result = await ajax.post(`import/load-excel-to-collection-report-data-table`, val, {
        networkParams: { showLoader: false },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          progressCallback(percentCompleted);
        },
      });
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCollectionReportDataForDisplay = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/get-collection-report-data-for-display', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const getAllCollectionReportDataForDisplay = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/get-all-collection-report-data-for-display', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const getSelectedCellsReportDataForDisplay = useCallback(
    async (values) => {
      try {
        const result = await ajax.post(
          'import/get-selected-cells-collection-report-data-for-display',
          values,
        );
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const checkDataExist = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/check-data-exist`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getAllImportTracker = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-all-import-tracker`, val);
      return result;
    } catch (error) {
      return error;
    }
  });
  const getListPersonalCsvData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-list-personal-csv-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getListFinancialPerformanceEmployeeCSVData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-list-financial-performance-employee-csv-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getListEmployeeRecordsCsvData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-list-employee-records-csv-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getListConpanyFinacialProgressionCsvData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-list-conpany-finacial-progression-csv-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getListFinancialCompensationCSVData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-list-financial-compensation-csv-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getListCollectionReportCSVData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-list-collection-report-csv-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCollectionReportData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-collection-report-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getFinancialCompensationDataByEmailId = useCallback(async (val) => {
    try {
      let result = await ajax.post(`import/get-financial-compensation-data-by-email-id`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getAllFinancialCompensationData = useCallback(async () => {
    try {
      let result = await ajax.post(`import/get-all-financial-compensation-data`);
      return result;
    } catch (error) {
      return error;
    }
  });

  const updateCollectionReportData = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-collection-report-data', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  const updateDropdown = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('import/update-dropdown', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  return {
    importDataToTable,
    updateDataToTable,
    getImportFieldNames,
    getSampleData,
    getConpanyFinacialProgressionData,
    getPersonalData,
    loadExcelDataToMainTable,
    checkDataExist,
    getAllImportTracker,
    updateConpanyFinacialProgressionData,
    updatePersonalData,
    updateFinancialCompensationData,
    getFinancialCompensationData,
    importCsvData,
    importCollectionReportData,
    getListConpanyFinacialProgressionCsvData,
    getListPersonalCsvData,
    loadExcelDataToConpanyFinacialProgressionTable,
    loadExcelDataToPersonalDataTable,
    loadExcelDataToFinancialCompensationDataTable,
    getEmployeeRecordsData,
    updateEmployeeRecordsData,
    loadExcelDataToEmployeeRecordsDataTable,
    getListEmployeeRecordsCsvData,
    getFinancialPerformanceEmployeeData,
    updateFinancialPerformanceEmployeeData,
    getListFinancialPerformanceEmployeeCSVData,
    loadFinancialPerformanceEmployeeData,
    getListFinancialCompensationCSVData,
    getCollectionReportData,
    updateCollectionReportData,
    loadExcelDataToCollectionReportTable,
    updateDropdown,
    getCollectionReportDataForDisplay,
    getAllCollectionReportDataForDisplay,
    getListCollectionReportCSVData,
    getFinancialCompensationDataByEmailId,
    getAllFinancialCompensationData,
    getSelectedCellsReportDataForDisplay,
  };
};

export default useImport;
